/**
 * Parallax Effects - BRONCANO
 * Efectos de parallax y animaciones avanzadas
 */

let ticking = false;

initializeParallaxEffects();
setupScrollAnimations();

function initializeParallaxEffects() {
    const parallaxElements = document.querySelectorAll('.parallax-on-scroll');
    
    if (parallaxElements.length === 0) return;

    let ticking = false;

    function updateParallax() {
        const scrollTop = window.pageYOffset;
        const windowHeight = window.innerHeight;

        parallaxElements.forEach(element => {
            const elementRect = element.getBoundingClientRect();
            const elementHeight = elementRect.height;
            const speed = parseFloat(element.dataset.speed) || 0.5;
            
            // New "floating" calculation
            const elementCenter = elementRect.top + elementHeight / 2;
            const viewportCenter = window.innerHeight / 2;
            const yPos = (elementCenter - viewportCenter) * speed * -1; // Multiply by -1 to move against the scroll

            // Only apply parallax if the element is in the viewport
            if ((elementRect.top < windowHeight) && (elementRect.bottom > 0)) {
                element.style.setProperty('--parallax-y', `${yPos}px`);
            }
        });
        ticking = false;
    }

    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(updateParallax);
            ticking = true;
        }
    });
}

function setupScrollAnimations() {
    // Animación del header en scroll
    const header = document.querySelector('.nav-container');
    const heroSection = document.querySelector('.main-header');
    
    if (header && heroSection) {
        window.addEventListener('scroll', function() {
            const scrollY = window.scrollY;
            const heroHeight = heroSection.offsetHeight;
            
            if (scrollY > heroHeight * 0.1) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        });
    }

    // Animación de elementos al hacer scroll
    setupScrollTriggers();
}

function setupScrollTriggers() {
    // Únicamente elementos no manejados por intersection-observer.js
    const triggerElements = document.querySelectorAll('.uas-text-block');
    
    if (triggerElements.length === 0) return; // Evitar crear observer innecesario
    
    const scrollObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const element = entry.target;
                const delay = Array.from(element.parentNode.children).indexOf(element) * 150;
                
                setTimeout(() => {
                    element.classList.add('scroll-triggered');
                }, delay);
                
                scrollObserver.unobserve(element);
            }
        });
    }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    });

    triggerElements.forEach(element => {
        scrollObserver.observe(element);
    });
}

// Efectos de hover mejorados
setupHoverEffects();

function setupHoverEffects() {
    // Efecto hover para elementos wasp-hex-item
    const hexItems = document.querySelectorAll('.wasp-hex-item');
    
    hexItems.forEach(item => {
        item.addEventListener('mouseenter', function() {
            this.style.transform = 'translateY(-2px) scale(1.02)';
            
            const icon = this.querySelector('.wasp-hex-icon');
            if (icon) {
                icon.style.transform = 'scale(1.1) rotate(5deg)';
            }
        });
        
        item.addEventListener('mouseleave', function() {
            this.style.transform = 'translateY(0) scale(1)';
            
            const icon = this.querySelector('.wasp-hex-icon');
            if (icon) {
                icon.style.transform = 'scale(1) rotate(0deg)';
            }
        });
    });

    // Efecto hover para imágenes
    const images = document.querySelectorAll('.collage-item img');
    
    images.forEach(img => {
        img.addEventListener('mouseenter', function() {
            this.style.transform = 'scale(1.05) rotate(1deg)';
        });
        
        img.addEventListener('mouseleave', function() {
            this.style.transform = 'scale(1) rotate(0deg)';
        });
    });
}

// CSS adicional para animaciones
const parallaxStyles = `
    .nav-container {
        transition: all var(--transition-normal);
    }
    
    .nav-container.scrolled {
        background: rgba(0, 0, 0, 0.98);
        backdrop-filter: blur(20px);
        box-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
    }
    
    .scroll-triggered {
        animation: slideInUp var(--duration-normal) ease forwards;
    }
    
    @keyframes slideInUp {
        from {
            opacity: 0;
            transform: translateY(30px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    .wasp-hex-item {
        transition: all var(--transition-smooth);
    }
    
    .wasp-hex-icon {
        transition: all var(--transition-smooth);
    }
    
    .collage-item img,
    .uas-drone-image {
        transition: all var(--transition-smooth);
    }
`;

// Inyectar estilos
const parallaxStyleSheet = document.createElement('style');
parallaxStyleSheet.textContent = parallaxStyles;
document.head.appendChild(parallaxStyleSheet);